"use strict";

require("core-js/modules/es.array.iterator");

var curry2 = require("./curry2.js");

var go = require("./go.js");

var not = require("./not.js");

var when = require("./when.js");

module.exports = curry2(function either(f1, f2, ...args) {
  return go(f1(...args), when(not, () => f2(...args)), Boolean);
});